import {useState, useEffect} from 'react'
import './TableComponent.scss' // custom CSS/SASS styling
import {
  Column,
  FieldType,
  Filters,
  Formatters,
  GridOption,
  GridStateChange,
  GridStateType,
  OperatorType,
  SlickgridReact,
  SliderRangeOption,
  TreeToggledItem,
  TreeToggleStateChange,
} from 'slickgrid-react'
import {Loader} from '../../components/Loader'
import '../../../node_modules/@slickgrid-universal/common/dist/styles/css/slickgrid-theme-bootstrap.css'

import {Tooltip} from 'react-tooltip'
import {GeneReferenceFormatter, lengthFormatter, omimFormatter} from './Formatters'

const TableComponentTreeData = ({
  data,
  selectedRows,
  setSelectedRows,
  selectedWidgetItem,
  setSelectedWidgetItem,
  tableHeader,
  runId = '',
  gridOptions,
  setGridOptions,
  gridId,
}) => {
  // const [loadingClass, setLoadingClass] = useState('')
  // const [isLargeDataset, setIsLargeDataset] = useState(false)
  const [hasNoExpandCollapseChanged, setHasNoExpandCollapseChanged] = useState(true)
  const [uniqueData, setUniqueData] = useState([])
  const [treeToggleItems, setTreeToggleItems] = useState<TreeToggledItem[]>([])
  const [columnDefinitions, setColumnDefinitions] = useState<Column[]>([])

  const onGrid1SelectedRowsChanged = (_e: Event, args: any) => {
    const grid = args && args.grid
    if (Array.isArray(args.rows)) {
      setSelectedRows(
        args.rows.map((idx: number) => {
          const item = grid.getDataItem(idx)
          return item
        })
      )
    }
  }
  function getGeneNameListUnique(data: {[key: string]: any}[], columnKey: string): string[] {
    const uniqueValues: string[] = []

    for (const item of data) {
      const values = item[columnKey] // columnKey ile belirtilen değeri al

      if (Array.isArray(values)) {
        for (const value of values) {
          if (!uniqueValues.includes(value)) {
            uniqueValues.push(value)
          }
        }
      }
    }

    return uniqueValues
  }
  function getColorBySVType(type) {
    const colorMap = {
      DEL: '#F7D8DD',
      DUP: '#DFE9FF',
      INS: '#FFCCEF',
      INV: '#FEE7CD',
      BND: '#FFFF99',
      CPX: '#D4F7DC',
    }

    return colorMap[type] || '#E0CCFF'
  }
  function getViridisColor(index) {
    const viridisColors = [
      '#fde725', // 0 - sarı
      '#b5de2b', // 1 - yeşilimsi sarı
      '#73d055', // 2 - açık yeşil
      '#5ec962', // 3 - yeşil
      '#3dbc74', // 4 - yeşil-mavi
      '#21918c', // 5 - cam göbeği
      '#31688e', // 6 - koyu mavi
      '#3b528b', // 7 - indigo
      '#472d7b', // 8 - mor
      '#440154', // 9 - en koyu mor
    ]

    if (index < 0 || index > 9) {
      throw new Error('Index must be between 0 and 9')
    }

    return viridisColors[index]
  }
  const getUniqueValues = (data: {[key: string]: any}[], columnKey: string) => {
    const uniqueValues = Array()
    for (const item of data) {
      if (!uniqueValues.includes(item[columnKey])) {
        uniqueValues.push(item[columnKey])
      }
    }
    return uniqueValues
  }
  function handleLinkClick(e) {
    e.preventDefault()
    const href = e.target.getAttribute('href')
    if (href && href !== '#') {
      window.open(href, '_blank')
    }
  }

  function customListFilter(value, filterValue) {
    if (!filterValue) return true // Eğer filtre değeri boşsa, tüm satırları göster
    const filterValues = filterValue.split(',').map((v) => v.trim()) // Filtre değerini virgülle ayır ve trim işlemi yap
    return filterValues.includes(value) // Hücre değerinin bu listedeki bir değere eşit olup olmadığını kontrol et
  }
  useEffect(() => {
    if (data.length > 1) {
      var olderParent = null
      const uniqueData = data.map((item, index) => {
        index++
        if (item.parentId === null) {
          olderParent = index
        }
        return {...item, id: index, parentId: item.parentId === null ? null : olderParent}
      })
      setUniqueData(uniqueData)
      defineGrid()
    }
  }, [])
  const chromComparator = (a, b) => {
    const extractChromNumber = (chrom) => {
      const match = chrom.match(/^chr(\d+|[XYM])$/i)
      if (!match) return chrom
      const value = match[1]
      if (value === 'X') return 23
      if (value === 'Y') return 24
      if (value === 'M') return 25
      return parseInt(value, 10)
    }

    const chromA = extractChromNumber(a)
    const chromB = extractChromNumber(b)

    return chromA - chromB
  }
  const fusionChromComparator = (a, b) => {
    const extractChromNumber = (chrom) => {
      const match = chrom.match(/^chr(\d+|[XYM]):/i)
      if (!match) return 1000 // Eğer match bulunamazsa, büyük bir sayı döndürerek sıralamada en sona koyma
      const value = match[1]
      if (value === 'X') return 23
      if (value === 'Y') return 24
      if (value === 'M') return 25
      return parseInt(value, 10)
    }

    const chromA = extractChromNumber(a)
    const chromB = extractChromNumber(b)

    return chromA - chromB
  }

  const defineGrid = () => {
    const columnDefs = Object.keys(tableHeader).map((columnKey) => {
      let additionalProps = {}
      if (columnKey === 'loeufColumn') {
        additionalProps = {
          formatter: (_row, _cell, value) => {
            return `<div style="background:${getViridisColor(
              value
            )};width:20px;height:inherit;"></div>`
          },
          width: 15,
          minWidth: 15,
          filterable: false,
          frozen: true,
          name: '',
        }
      }
      if (columnKey === 'reportSelect') {
        additionalProps = {
          frozen: true,
          formatter: Formatters.tree,
          minWidth: 30,
          name: '',
          filterable: false,
          sortable: false,
        }
      }
      if (columnKey === 'OMIMID') {
        additionalProps = {
          formatter: omimFormatter,
          onCellClick: handleLinkClick,
        }
      }

      if (columnKey === 'external') {
        return {
          id: 'External',
          name: 'External',
          field: 'External',
          cssClass: 'cell-title text-center cursor-pointer',
          minWidth: 60,
          width: 60,
          filterable: true,
          sortable: true,
          formatter: (_row, _cell, _value, _columnDef, dataContext) => {
            return `
              <div class="external-dropdown-container">
                <i class="fas fa-ellipsis-v"></i> 
                <div class="external-dropdown hidden">
                  <ul>
                    <li><a href="https://www.google.com/search?q=${dataContext.Start}" target="_blank">Google (${dataContext.Start})</a></li>
                    <li><a href="https://www.bing.com/search?q=${dataContext.End}" target="_blank">Bing (${dataContext.End})</a></li>
                    <li><a href="https://www.yahoo.com/search?q=${dataContext.Chrom}" target="_blank">Yahoo (${dataContext.Chrom})</a></li>
                  </ul>
                </div>
              </div>
            `
          },
          onCellClick: (e, args) => {
            e.stopPropagation()

            const grid = args.grid
            const cellNode = grid.getCellNode(args.row, args.cell)
            if (!cellNode) return
            let dropdown = document.querySelector('.external-dropdown') as HTMLElement
            if (dropdown && dropdown.dataset.activeCell === `${args.row}-${args.cell}`) {
              dropdown.remove()
              return
            }

            document.querySelectorAll('.external-dropdown').forEach((el) => el.remove())

            dropdown = document.createElement('div')
            dropdown.className = 'external-dropdown'
            document.body.appendChild(dropdown)

            const rect = cellNode.getBoundingClientRect()
            let dropdownTop = rect.bottom + window.scrollY
            let dropdownLeft = rect.left + window.scrollX

            if (dropdownTop + 200 > window.innerHeight + window.scrollY) {
              dropdownTop = rect.top + window.scrollY - 210
              dropdown.classList.add('flip-up')
            } else {
              dropdown.classList.remove('flip-up')
            }

            dropdown.style.position = 'absolute'
            dropdown.style.top = `${dropdownTop}px`
            dropdown.style.left = `${dropdownLeft}px`
            dropdown.style.zIndex = '9999999'
            dropdown.style.background = '#fff'
            dropdown.style.boxShadow = '0px 4px 10px rgba(0, 0, 0, 0.2)'
            dropdown.style.padding = '8px'
            dropdown.style.borderRadius = '6px'
            dropdown.style.fontSize = '14px'
            dropdown.style.width = '120px'

            dropdown.dataset.activeCell = `${args.row}-${args.cell}`
            const franklinUrl = `https://franklin.genoox.com/clinical-db/variant/svTumor/${
              args.dataContext.Chrom
            }-${args.dataContext.Start}-${
              args.dataContext.End
            }-${args.dataContext.SVType.toLowerCase()}-hg38`
            dropdown.innerHTML = `
              <ul style="list-style: none; padding: 0; margin: 0;">
                <li style="padding: 5px;display:flex; align-items:center; gap:5px">  <a href="${franklinUrl}" target="_blank"><i  class="fa fa-link text-danger "></i> Franklin</a></li>
              </ul>
            `

            dropdown.classList.add('show')

            setTimeout(() => {
              // Detect click on the document
              document.addEventListener(
                'click',
                (ev) => {
                  if (
                    !dropdown.contains(ev.target as Node) &&
                    !cellNode.contains(ev.target as Node)
                  ) {
                    dropdown.remove()
                  }
                },
                {once: true}
              )
            }, 10)

            // Close the dropdown when a link is clicked
            const links = dropdown.querySelectorAll('a')
            links.forEach((link) => {
              link.addEventListener('click', () => {
                dropdown.remove()
              })
            })
          },
        }
      }

      if (columnKey === 'igv') {
        return {
          id: columnKey,
          name: 'IGV',
          field: columnKey,
          cssClass: 'cell-title text-center cursor-pointer',
          minWidth: 30,
          width: 30,
          filterable: false,
          sortable: false,
          formatter: (row, cell, value, columnDef, dataContext) => {
            return `
            <i class="fas fa-external-link-alt"></i>
            `
          },
          onCellClick: (e, args) => {
            e.preventDefault()
            console.log('sa')
            if (args.columnDef.field === 'igv') {
              const sType = gridId === 'germlineTable' ? 'germline' : 'somatic'
              window.open('/igv/' + runId + '&' + args.dataContext.igv + '&sv&' + sType, '_blank')
            }
          },
        }
      }
      // if columnkey is SvType made badge
      if (columnKey === 'SVType') {
        additionalProps = {
          formatter: (_row, _cell, value) => {
            return `<span class="badge badge-info text-dark" style="background-color:${getColorBySVType(
              value
            )}">${value}</span>`
          },
        }
      }

      let filter
      if (
        columnKey === 'Chrom' ||
        columnKey === 'SVType' ||
        columnKey === 'OMIMInheritance' ||
        columnKey === 'ACMGClass' ||
        columnKey === 'OncoKBSVType' ||
        columnKey === 'MutationEffect' ||
        columnKey === 'Oncogenic' ||
        columnKey === 'HighestLevel' ||
        columnKey === 'HighestSensitiveLevel' ||
        columnKey === 'HighestResistanceLevel' ||
        columnKey === 'HighestDxLevel' ||
        columnKey === 'HighestPxLevel' ||
        columnKey === 'Zygosity' ||
        columnKey === 'NearestSSType' ||
        columnKey === 'PGainSource' ||
        columnKey === 'BGainSource' ||
        columnKey === 'PLossSource' ||
        columnKey === 'BLossSource' ||
        columnKey === 'PInsSource' ||
        columnKey === 'BInsSource' ||
        columnKey === 'BInvSource' ||
        columnKey === 'PoBGainSomeGSource' ||
        columnKey === 'PoBGainAllGSource' ||
        columnKey === 'PoBLossSomeGSource' ||
        columnKey === 'PoBLossAllGSource' ||
        columnKey === 'Frameshift' ||
        columnKey === 'PoPGainSource' ||
        columnKey === 'PoPLossSource' ||
        columnKey === 'DDDStatus' ||
        columnKey === 'DDDMode' ||
        columnKey === 'DDDConsequence' ||
        columnKey === 'GenCCMoi' ||
        columnKey === 'GenCCClassification' ||
        columnKey === 'OMIMInheritance' ||
        columnKey === 'OMIMMorbidCandidate' ||
        columnKey === 'OMIMMorbid' ||
        columnKey === 'ACMGClass' ||
        columnKey === 'OncoKBGene'
      ) {
        const uniqueValues = getUniqueValues(data, columnKey)
        const collection = uniqueValues.map((value) => {
          // Boş olup olmadığını ve string tipinde olup olmadığını kontrol et
          if (typeof value === 'string' && value.trim() !== '') {
            // Eğer label 20 karakterden uzunsa ilk 20 karakteri al ve sonuna '...' ekle
            const label = value.length > 20 ? value.slice(0, 20) + '...' : value
            return {value, label}
          }

          // Eğer value boşsa veya uygun değilse default bir label koy (örneğin 'N/A')
          return {value, label: ''}
        })
        filter = {
          model: Filters.multipleSelect,
          collection,
          filterOptions: {
            autoDropWidth: true,
          },
        }
      }
      if (columnKey === 'GeneName') {
        additionalProps = {
          formatter: GeneReferenceFormatter,
          onCellClick: handleLinkClick,
        }
      }
      if (columnKey === 'GeneName' || columnKey === 'FILTER') {
        const uniqueValues = getGeneNameListUnique(data, columnKey)
        const collection = uniqueValues
          .sort() // Alfabetik sıralama
          .map((value) => ({value, label: value}))
        filter = {
          model: Filters.multipleSelect,
          operator: OperatorType.inContains, // defaults to inclusive

          collection,
          filterOptions: {
            autoDropWidth: true,
          },
        }
      }
      if (columnKey === 'DET') {
        const uniqueValues = getUniqueValues(data, columnKey)
        const collection = uniqueValues.map((value) => ({value, label: value}))

        filter = {
          model: Filters.singleSelect,
          collection,
          filterOptions: {
            autoDropWidth: true,
          },
        }
      }
      if (columnKey === 'Start' || columnKey === 'End' || columnKey === 'Length') {
        filter = {
          model: Filters.compoundInputText,
          // operator: '>=',
        }
        additionalProps = {
          type: FieldType.number,
        }
      }
      if (
        columnKey === 'GeneInOncoKB' ||
        columnKey === 'VariantInOncoKB' ||
        columnKey === 'OMIMID'
      ) {
        filter = {
          model: Filters.select,
          collection: ['true', 'false', ''],
          filterOptions: {
            autoDropWidth: true,
          },
        }
      }
      if (
        columnKey === 'GnomADPLI' ||
        columnKey === 'ExACPLI' ||
        columnKey === 'Length' ||
        columnKey === 'DistNearestSS' ||
        columnKey === 'DDDHiPercent' ||
        columnKey === 'QUAL' ||
        columnKey === 'ExonCount' ||
        columnKey === 'LOEUFBin' ||
        columnKey === 'GnomADPLI' ||
        columnKey === 'ExACPLI' ||
        columnKey === 'GeneCount'
      ) {
        filter = {
          model: Filters.compoundInputText,
          // operator: '>=',
        }
        additionalProps = {
          type: FieldType.number,
        }
      }
      // if (columnKey === 'Start' || columnKey === 'Chrom') {
      //   additionalProps = {
      //     columnGroup: 'Deneme Grubu',
      //   }
      // }
      // if (columnKey === 'End' || columnKey === 'Length') {
      //   additionalProps = {
      //     columnGroup: 'Deneme Grubu 2',
      //   }
      // }
      // if (columnKey === 'Length') {
      //   additionalProps = {
      //     formatter: lengthFormatter,
      //   }
      // }

      return {
        id: columnKey,
        name: tableHeader[columnKey].value,
        columnGroup: tableHeader[columnKey].columnGroup,
        field: columnKey,
        headerCssClass: 'header-title',

        cssClass: 'cell-title',
        minWidth: 120,
        filterable: true,
        sortable: true,
        formatter: (row, cell, value, columnDef, dataContext) => {
          const extraClass = dataContext.parentId !== null ? 'tree-data' : 'parent-data'
          if (columnKey === 'Length') {
            return `<div class="${extraClass}">${lengthFormatter(
              row,
              cell,
              value,
              columnDef,
              dataContext
            )}</div>`
          }
          return `<div class="${extraClass}">${
            value === null || value === '' || value === undefined ? '.' : value
          }</div>`
        },
        ...additionalProps,
        filter,
        ...(columnKey === 'Chrom'
          ? {
              sortComparer: (a, b, sortDirection) => {
                const result = chromComparator(a, b)
                return sortDirection === 1 ? result : -result
              },
            }
          : {}),
      }
    })

    const gridOpts: GridOption = {
      autoResize: {
        container: '#demo-container',
        rightPadding: 10,
      },
      enableAutoSizeColumns: true,
      enableAutoResize: true,
      enableFiltering: true,
      frozenColumn: 2,
      enableRowSelection: true,
      enableCheckboxSelector: true,
      enableTreeData: true,
      createPreHeaderPanel: true,
      showPreHeaderPanel: true,
      preHeaderPanelHeight: 53,
      checkboxSelector: {
        hideSelectAllCheckbox: true,
      },
      treeDataOptions: {
        columnId: 'reportSelect',
        parentPropName: 'parentId',
        levelPropName: 'treeLevel',
        indentMarginLeft: 15,
        initiallyCollapsed: true,
        initialSort: {
          columnId: 'id',
          direction: 'ASC',
        },
      },
      enablePagination: false,
      multiColumnSort: false,
      showCustomFooter: true,
      headerRowHeight: 40,
      rowHeight: 30,
    }
    setColumnDefinitions(columnDefs)
    setGridOptions(gridOpts)
  }
  console.log(columnDefinitions)
  // const hideSpinner = () => {
  //   setTimeout(() => {
  //     setLoadingClass('')
  //   }, 200)
  // }

  // const showSpinner = () => {
  //   if (isLargeDataset) {
  //     setLoadingClass('fa fa-refresh fa-spin')
  //   }
  // }

  // const handleOnTreeFullToggleEnd = (_treeToggleExecution: TreeToggleStateChange) => {
  //   hideSpinner()
  // }

  const handleOnTreeItemToggled = (treeToggleExecution: TreeToggleStateChange) => {
    setHasNoExpandCollapseChanged(false)
    setTreeToggleItems(treeToggleExecution.toggledItems as TreeToggledItem[])
  }

  const handleOnGridStateChanged = (gridStateChange: GridStateChange) => {
    setHasNoExpandCollapseChanged(false)

    if (gridStateChange?.change?.type === GridStateType.treeData) {
      setTreeToggleItems(gridStateChange?.gridState?.treeData?.toggledItems as TreeToggledItem[])
    }
  }
  const onCellClicked = (e: any, args: any) => {
    const grid = args && args.grid
    const rows = document.querySelectorAll('.slick-row')
    rows.forEach((row) => {
      row.classList.remove('background-red')
    })

    if (e.target.parentElement.parentElement.classList.contains('slick-row')) {
      e.target.parentElement.parentElement.classList.add('background-red')
    }
    setSelectedWidgetItem(grid.getDataItem(args.row))
  }

  if (data.length < 1) {
    return <div className='  text-center'>There is no data</div>
  }
  return data.length < 1 || !gridOptions || gridOptions === undefined ? (
    <div className='card'>
      <div className='card-body text-center'>
        <Loader />
      </div>
    </div>
  ) : (
    <div id='demo-container' className='container-fluid mt-5' style={{overflow: 'hidden'}}>
      <div id='grid-container' className='col-sm-12'>
        <SlickgridReact
          gridId={gridId}
          columnDefinitions={columnDefinitions}
          gridOptions={gridOptions}
          dataset={uniqueData}
          // onBeforeFilterChange={() => showSpinner()}
          // onFilterChanged={() => hideSpinner()}
          // onBeforeFilterClear={() => showSpinner()}
          // onFilterCleared={() => hideSpinner()}
          // onBeforeSortChange={() => showSpinner()}
          // onSortChanged={() => hideSpinner()}
          // onBeforeToggleTreeCollapse={() => showSpinner()}
          // onToggleTreeCollapsed={() => hideSpinner()}
          // onTreeFullToggleStart={() => showSpinner()}
          // onTreeFullToggleEnd={($event) => handleOnTreeFullToggleEnd($event.detail)}
          onTreeItemToggled={($event) => handleOnTreeItemToggled($event.detail)}
          onGridStateChanged={($event) => handleOnGridStateChanged($event.detail)}
          onSelectedRowsChanged={($event) =>
            onGrid1SelectedRowsChanged($event.detail.eventData, $event.detail.args)
          }
          onClick={($event) => {
            onCellClicked($event.detail.eventData, $event.detail.args)
          }}
        />
        <Tooltip id='my-tooltip' />
      </div>
    </div>
  )
}

export default TableComponentTreeData
